import { FaStore } from 'react-icons/fa';
import { SaleProjectsViewMain } from '../Components/SaleProjectsViewMain';

export const SaleProjectsModule = () => [{
    views: 'PRIVATE',
    path: '/dashboard/proyectos-en-venta',
    component: <SaleProjectsViewMain />,
    roles: null,
    permissions: null,
    label: 'Proyectos en venta',
    icon: <FaStore />,
    displayInHeader: false,
    displayInFooter: false,
    displayInSidebar: true,
    isBlockedWhenLogged: false,
}];
